<template>
    <form-row title="Who Pays for the Final Plat?">
        <buyer-seller-split
            field="final_plat_who_pays"
            :value="commercial.final_plat_who_pays"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../../buyer-seller-split.vue';

export default {
    components: {
        BuyerSellerSplit,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
